import { render, staticRenderFns } from "./ProformaTermForm.vue?vue&type=template&id=3284a5a2&"
import script from "./ProformaTermForm.vue?vue&type=script&lang=js&"
export * from "./ProformaTermForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports